import React, {Component} from 'react';

export default class RadioInput extends Component {

    renderOptions(inputName, listValues) {

        return listValues.map((el, i)=>{

            const rndKey=Math.floor(Math.random() * Math.floor(1000000));
            return (
                <React.Fragment key={rndKey}>
                    <label style={{display: 'block', padding: '6px 0', cursor: 'pointer'}}>
                        <input name={inputName} type={"radio"} value={el} style={{marginRight: '8px', transform: 'scale(1.3)'}}/>{el}
                    </label>
                </React.Fragment>
            );
        });
    }

    render() {
        const question = this.props.question;
        const name = this.props.name;
        const options = this.props.options;

        if(!options) {
            return null;
        }

        return (
            <div style={{fontSize: '1.1em', lineHeight: '1.6'}}>
                <div style={{fontWeight: 'bold', marginBottom: '12px'}}>{question}</div>
                {this.renderOptions(name, options)}
            </div>
        )
    }
}
